import { Lightning, Router } from '@lightningjs/sdk'

import { getColor, grey400, primary400, white } from '../../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../../constants/fonts'
import { MessageModelStyle, MessageModelStylesEnum, MessageModelType } from '../../types/flo-enums'
import { MessageModel } from '../../types/flo-experience'
import { CAROUSEL_MARGIN_BOTTOM } from '../../utils/carouselUtils'
import { getText } from '../../utils/dictionary'
import Button from '../button/button'

const MESSAGE_MARGIN_BOTTOM = 16

export default class Message extends Lightning.Component {
  private _data: MessageModel
  private _style: MessageModelStyle
  private _type: MessageModelType
  private _rowIndex = 0

  static _template() {
    return {
      w: (w) => w,
      flex: {
        direction: 'column',
        justifyContent: 'space-between',
      },
      Message: {
        text: {
          text: '',
          fontSize: 48,
          fontFace: UniNeueBold,
          lineHeight: 56,
          textColor: getColor(primary400),
          textAlign: 'left',
        },
      },
      BackButton: {
        type: Button,
      },
    }
  }

  get message() {
    return this.tag('Message')
  }

  get backButton() {
    return this.tag('BackButton') as Button
  }

  set data(v: MessageModel) {
    this._data = v
    const isAlternate = this._data.style === MessageModelStylesEnum.Alternate
    const isNoContent = this._data.style === MessageModelStylesEnum.NoContent

    const fontSize = isAlternate ? 32 : 48
    const fontFace = isAlternate ? UniNeueRegular : UniNeueBold
    const lineHeight = isAlternate ? 45 : 56
    const textAlign = isAlternate ? 'center' : 'left'

    let textColor = getColor(white)
    if (isNoContent) {
      textColor = getColor(primary400)
    } else if (isAlternate) {
      textColor = getColor(grey400)
    }

    if (isAlternate) {
      this.patch({
        flex: {
          justifyContent: 'flex-end',
          alignItems: 'center',
        },
      })
    }

    this.message.patch({
      text: {
        fontSize: fontSize,
        fontFace: fontFace,
        lineHeight: lineHeight,
        textAlign: textAlign,
        textColor: textColor,
        text: this._data.text,
      },
    })

    this.backButton.patch({
      visible: isNoContent,
      icon: 'icon-back-arrow',
      label: getText('goBackButton'),
    })
  }

  get data() {
    return this._data
  }

  set rowIndex(v) {
    this._rowIndex = v
  }

  get rowIndex() {
    return this._rowIndex
  }

  set style(v) {
    this._style = v

    this.backButton.patch({
      visible: this._style === MessageModelStylesEnum.NoContent,
    })
  }

  get style() {
    return this._style
  }

  set type(v) {
    this._type = v
  }

  get type(): MessageModelType {
    return this._type
  }

  set isCarousel(v: boolean) {
    if (v) {
      this.patch({
        flexItem: {
          marginBottom: CAROUSEL_MARGIN_BOTTOM,
        },
      })
      this.message.patch({
        flexItem: {
          marginBottom: MESSAGE_MARGIN_BOTTOM,
        },
      })
    }
  }

  get currentChild() {
    return this._style === MessageModelStylesEnum.NoContent ? this.backButton : this.message
  }

  _getFocused() {
    return this.currentChild
  }

  _handleEnter() {
    if (this.currentChild === this.backButton) {
      Router.back()
    } else {
      // Bubbles up the event so the parent component can act on it
      return false
    }
  }

  _handleClick() {
    this._handleEnter()
  }
}
